import gql from "graphql-tag";

const CREATE_BATCH_EXPORT_TO_ACCOUNTS = gql`
  mutation createBatchExportToAccounts($input: BatchExportToAccountsInput!) {
    createBatchExportToAccounts(input: $input) {
      id
    }
  }
`;
export default {
  data() {
    return {
      batchExportTask: null,
      showBatchExportTaskStatus: false,
    };
  },
  methods: {
    async batchExportToAccounts(list, name, target = "xero") {
      const input = {
        name,
        recordsIds: list.map((r) => (r.node ? r.node.id : r.id)),
        target,
      };
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CREATE_BATCH_EXPORT_TO_ACCOUNTS,
          variables: { input: { ...input } },
        });
        this.batchExportTask = { ...data.createBatchExportToAccounts };
        this.showBatchExportTaskStatus = true;
      } catch (error) {
        const errorMsg = (error.graphQLErrors || [])
          .map((e) => e.message)
          .join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg || error.message,
          color: "error",
        });
      }
    },
    onBatchExportToAccountsComplete(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: result.taskStatus.notes,
        color: result.taskStatus.status == "ERROR" ? "error" : "success",
      });
      this.showBatchExportTaskStatus = false;
      if (this.$apollo.queries.purchaseInvoices != null) {
        this.$apollo.queries.purchaseInvoices.refetch();
      }
      if (this.$apollo.queries.salesInvoices != null) {
        this.$apollo.queries.salesInvoices.refetch();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/gt/finances/purchase-invoices/batch-export-to-accounts-mixin.js